<template>
  <Modal :class="dialogClassName">
    <template slot="header">
      <div class="icon">
        <img :src="dialogData.icon">
      </div>
      <div class="dialog-title">{{ dialogData.lTitle }}</div>
    </template>

    <template slot="body">
      <div class="dailog-content">
        <p v-html="dialogData.content"/>
        <div class="content-extra">
          {{ dialogData.contentExtra }}
        </div>  
      </div>
    </template>

    <template slot="footer">
      
        <template v-if="dialogData.type==1">
          <div class="btn-group">
            <div 
              class="left-btn" 
              @click="$emit('close')"
            >
              {{ dialogData.leftBtnText }}
            </div>
            <div 
              class="right-btn" 
              @click="$emit('sure')">{{ dialogData.rightBtnText }}</div>
          </div>
        </template>
        <template v-else>  
          <div 
            class="center-btn" 
            @click="$emit('sure')">{{ dialogData.rightBtnText }}</div>
        </template>
      
    </template>
  </Modal>
</template>
<script>
import Modal from './modal';
export default {
  components: {
    Modal
  },
  props: {
    className: {
      type: String,
      default() {
        return '';
      }
    },
    dialogData: {
      type: Object,
      default: function() {
        return {
          icon: '',
          lTitle: '',
          content: '',
          contentExtra: '',
          type: 1,
          leftBtnText: '',
          rightBtnText: ''
        };
      }
    }
  },
  data() {
    return {
      dialogClassName: ''
    };
  },
  created() {
    this.dialogClassName = 'dialogbtn' + this.className;
  }
};
</script>

<style lang="scss" scoped>
@import "../mixin.scss";
.dialogbtn {
  /deep/ .lite-modal-body {
    margin: 12px 0;
  }

  .icon {
    text-align: center;
    height: 50px;
    img {
      width: 50px;
      height: 50px;
    }
  }

  .dialog-title {
    margin-top: 7px;
    font-size: 18px;
    font-weight: bold;
    color: #282B4A;
    text-align: center;
  }

  .dailog-content {
    margin-left: 17px;
    margin-right: 17px;
    font-size: 15px;
    font-weight: 300;
    color: #22243D;
    line-height: 25px;
    opacity: 0.8;

    .content-extra {
      font-weight: bold;
      background: #EEEEEE;
      border-radius: 3px;
      font-style: italic;
    }
  }

  .btn-group {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
  }
  .left-btn,
  .right-btn {
    flex: 1;
    color: $dialog-btn-color;
    font-size: 15px;
    font-weight: bold;
    padding: 11px 0;
    text-align: center;
    align-items: center;
    border-radius: 2.5px;
    cursor: pointer;
  }
  .left-btn {
    background: $dialog-btn-background;
  }
  .right-btn {
    background: $status-color;
    color: $word-color;
  }

  .center-btn {
    margin: auto;
    width: 94%;
    font-size: 15px;
    font-weight: bold;
    padding: 11px 0;
    text-align: center;
    align-items: center;
    border-radius: 2.5px;
    background: #00F3AB;
    color: #fff;
    cursor: pointer;
  }
}
</style>
